import { Minus, Plus } from 'lucide-react';

export interface StepperProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
}

/** A count with big − / + buttons, easy to hit on a phone; the number can be typed too. */
export function Stepper({ label, value, onChange, min = 0, max = 50 }: StepperProps) {
  const set = (next: number) => onChange(Math.min(max, Math.max(min, next)));
  return (
    <div>
      <span className="block text-sm font-medium text-gray-700 mb-1">{label}</span>
      <div className="inline-flex items-center rounded-xl border border-gray-300 bg-white">
        <button
          type="button"
          onClick={() => set(value - 1)}
          disabled={value <= min}
          aria-label={`Fewer ${label.toLowerCase()}`}
          className="h-11 w-11 inline-flex items-center justify-center text-gray-700 disabled:opacity-30"
        >
          <Minus size={16} aria-hidden />
        </button>
        <input
          type="number"
          inputMode="numeric"
          min={min}
          max={max}
          value={value}
          aria-label={label}
          onChange={(e) =>
            set(e.target.value === '' ? min : Number.parseInt(e.target.value, 10) || 0)
          }
          className="w-12 h-11 text-center text-base border-x border-gray-200 focus:outline-none [appearance:textfield]"
        />
        <button
          type="button"
          onClick={() => set(value + 1)}
          disabled={value >= max}
          aria-label={`More ${label.toLowerCase()}`}
          className="h-11 w-11 inline-flex items-center justify-center text-gray-700 disabled:opacity-30"
        >
          <Plus size={16} aria-hidden />
        </button>
      </div>
    </div>
  );
}
